"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adapter = adapter;
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _objectWithoutProperties2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
var _excluded = ["id"],
  _excluded2 = ["id"],
  _excluded3 = ["id"],
  _excluded4 = ["id", "uid"],
  _excluded5 = ["id"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Department = /*#__PURE__*/function (_Service) {
  function Department() {
    (0, _classCallCheck2.default)(this, Department);
    return _callSuper(this, Department, arguments);
  }
  (0, _inherits2.default)(Department, _Service);
  return (0, _createClass2.default)(Department, [{
    key: "getList",
    value: function getList(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get("/v2/departments?".concat(_qs.default.stringify(param)));
    }
  }, {
    key: "add",
    value: function add(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post('/v2/department/add', param);
    }
  }, {
    key: "rename",
    value: function rename(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        other = (0, _objectWithoutProperties2.default)(param, _excluded);
      return this.http.post("/v2/department/edit/".concat(id), other);
    }
  }, {
    key: "moveDep",
    value: function moveDep(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        other = (0, _objectWithoutProperties2.default)(param, _excluded2);
      return this.http.post("/v2/department/move/".concat(id), other);
    }
  }, {
    key: "move",
    value: function move(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        other = (0, _objectWithoutProperties2.default)(param, _excluded3);
      return this.http.post("/v2/department/".concat(id, "/users/move"), other);
    }
  }, {
    key: "del",
    value: function del(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post("/v2/department/del/".concat(param.id, "?pid=").concat(param.pid));
    }
  }, {
    key: "getManager",
    value: function getManager(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get("/v2/department/".concat(param.id, "/manager?").concat(_qs.default.stringify(param.token), "&pid=").concat(param.pid));
    }
  }, {
    key: "setManager",
    value: function setManager(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        uid = param.uid,
        other = (0, _objectWithoutProperties2.default)(param, _excluded4);
      return this.http.post("/v2/department/".concat(id, "/manager/").concat(uid), other);
    }
  }, {
    key: "getEmployee",
    value: function getEmployee(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        other = (0, _objectWithoutProperties2.default)(param, _excluded5);
      return this.http.get("/v2/department/".concat(id, "/users?").concat(_qs.default.stringify(other)));
    }
  }]);
}(_serviceBase.default);
function adapter(arr) {
  var getTarget = function getTarget(arr, id) {
    return arr.find(function (e) {
      return e.id === id;
    });
  };
  var list = arr.filter(function (e) {
    return e.is_active || name === '';
  }).map(function (e) {
    return {
      label: e.name,
      id: e.id,
      parent: e.pid,
      children: [],
      sort: e.sort
    };
  });
  list.forEach(function (e) {
    var parent = getTarget(list, e.parent);
    if (parent) {
      parent.children[e.sort] = e;
    }
  });
  list.forEach(function (e) {
    e.children = e.children.filter(function (c) {
      return !!c;
    });
  });
  var root = list.find(function (e) {
    return e.parent === 0;
  });
  return [root];
}
var _default = exports.default = new Department({
  baseURL: process.env.VUE_APP_BASE_API_LOGIN
});